import {BaseModel} from '../base-model';

export class Identification extends BaseModel {
    id: string;
    type: string;
    number: string;
    issue_date: string;
    expire_date: string;
}
